import DataRoomDocumentMobileModal from './DataRoomDocumentMobileModal.component';

export default DataRoomDocumentMobileModal;
